import actions from './actions'
import mutations from './mutations'
import getters from './getters'
export default {
    state: {
        excuses: [],
        excuse_pages: 0,
        excuses_today: [],
        excuses_today_status: null,
    },
    actions,
    mutations,
    getters
}
